export enum CardTransactionErrors {
    INVALID_TRANSACTION_TYPE = 'INVALID_TRANSACTION_TYPE',
    MISSING_SHOPPER_OR_CARD_HOLDER = 'MISSING_SHOPPER_OR_CARD_HOLDER',
    INVALID_HTTP_METHOD = 'INVALID_HTTP_METHOD',
    INVALID_API_VERSION = 'INVALID_API_VERSION',
    PAYMENT_GENERAL_FAILURE = 'PAYMENT_GENERAL_FAILURE',
    VALIDATION_GENERAL_FAILURE = 'VALIDATION_GENERAL_FAILURE',
    INVALID_MERCHANT_TRANSACTION_ID = 'INVALID_MERCHANT_TRANSACTION_ID',
    INVALID_RECURRING_TRANSACTION = 'INVALID_RECURRING_TRANSACTION',
    MERCHANT_CONFIGURATION_ERROR = 'MERCHANT_CONFIGURATION_ERROR',
    MISSING_CARD_TYPE = 'MISSING_CARD_TYPE',
    XSS_EXCEPTION = 'XSS_EXCEPTION',
    THREE_D_SECURITY_AUTHENTICATION_REQUIRED = 'THREE_D_SECURITY_AUTHENTICATION_REQUIRED',
    AUTHORIZATION_AMOUNT_ALREADY_REVERSED = 'AUTHORIZATION_AMOUNT_ALREADY_REVERSED',
    AUTHORIZATION_AMOUNT_NOT_VALID = 'AUTHORIZATION_AMOUNT_NOT_VALID',
    AUTHORIZATION_EXPIRED = 'AUTHORIZATION_EXPIRED',
    AUTHORIZATION_NOT_FOUND = 'AUTHORIZATION_NOT_FOUND',
    BLS_CONNECTION_PROBLEM = 'BLS_CONNECTION_PROBLEM',
    CALL_ISSUER = 'CALL_ISSUER',
    CARD_LOST_OR_STOLEN = 'CARD_LOST_OR_STOLEN',
    CVV_ERROR = 'CVV_ERROR',
    DO_NOT_HONOR = 'DO_NOT_HONOR',
    EXPIRED_CARD = 'EXPIRED_CARD',
    GENERAL_PAYMENT_PROCESSING_ERROR = 'GENERAL_PAYMENT_PROCESSING_ERROR',
    HIGH_RISK_ERROR = 'HIGH_RISK_ERROR',
    INCORRECT_INFORMATION = 'INCORRECT_INFORMATION',
    INCORRECT_SETUP = 'INCORRECT_SETUP',
    INSUFFICIENT_FUNDS = 'INSUFFICIENT_FUNDS',
    INVALID_AMOUNT = 'INVALID_AMOUNT',
    INVALID_CARD_NUMBER = 'INVALID_CARD_NUMBER',
    INVALID_CARD_TYPE = 'INVALID_CARD_TYPE',
    INVALID_PIN_OR_PW_OR_ID_ERROR = 'INVALID_PIN_OR_PW_OR_ID_ERROR',
    INVALID_TRANSACTION = 'INVALID_TRANSACTION',
    LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
    PICKUP_CARD = 'PICKUP_CARD',
    PROCESSING_AMOUNT_ERROR = 'PROCESSING_AMOUNT_ERROR',
    PROCESSING_DUPLICATE = 'PROCESSING_DUPLICATE',
    PROCESSING_GENERAL_DECLINE = 'PROCESSING_GENERAL_DECLINE',
    PROCESSING_TIMEOUT = 'PROCESSING_TIMEOUT',
    REFUND_FAILED = 'REFUND_FAILED',
    RESTRICTED_CARD = 'RESTRICTED_CARD',
    SYSTEM_TECHNICAL_ERROR = 'SYSTEM_TECHNICAL_ERROR',
    THE_ISSUER_IS_UNAVAILABLE_OR_OFFLINE = 'THE_ISSUER_IS_UNAVAILABLE_OR_OFFLINE',
    THREE_D_SECURE_FAILURE = 'THREE_D_SECURE_FAILURE',
    PAYMENT_METHOD_NOT_SUPPORTED = 'PAYMENT_METHOD_NOT_SUPPORTED',
    NO_AVAILABLE_PROCESSORS = 'NO_AVAILABLE_PROCESSORS',
    SHOPPER_NOT_FOUND = 'SHOPPER_NOT_FOUND',
    SHOPPER_COUNTRY_OFAC_SANCTIONED = 'SHOPPER_COUNTRY_OFAC_SANCTIONED',
    MULTIPLE_PAYMENT_METHODS_NON_SELECTED = 'MULTIPLE_PAYMENT_METHODS_NON_SELECTED',
    MULTIPLE_TRANSACTIONS_FOUND = 'MULTIPLE_TRANSACTIONS_FOUND',
    TRANSACTION_LOCKED = 'TRANSACTION_LOCKED',
    TRANSACTION_PAYMENT_METHOD_NOT_SUPPORTED = 'TRANSACTION_PAYMENT_METHOD_NOT_SUPPORTED',
    TRANSACTION_NOT_AUTHORIZED = 'TRANSACTION_NOT_AUTHORIZED',
    TRANSACTION_ALREADY_EXISTS = 'TRANSACTION_ALREADY_EXISTS',
    TRANSACTION_EXPIRED = 'TRANSACTION_EXPIRED',
    INVALID_TRANSACTION_ID = 'INVALID_TRANSACTION_ID',
    TRANSACTION_ALREADY_CAPTURED = 'TRANSACTION_ALREADY_CAPTURED',
    CREDIT_CARD_DETAILS_PLAIN_AND_ENCRYPTED = 'CREDIT_CARD_DETAILS_PLAIN_AND_ENCRYPTED',
    CREDIT_CARD_ENCRYPTED_NUMBER_REQUIRED = 'CREDIT_CARD_ENCRYPTED_NUMBER_REQUIRED',
    CREDIT_CARD_ENCRYPTED_SECURITY_CODE_REQUIRED = 'CREDIT_CARD_ENCRYPTED_SECURITY_CODE_REQUIRED',
    STRONG_CUSTOMER_AUTHENTICATION_REQUIRED = 'STRONG_CUSTOMER_AUTHENTICATION_REQUIRED',
    TRANSACTION_ID_REQUIRED = 'TRANSACTION_ID_REQUIRED',
}
